export default __webpack_public_path__ + "static/media/ies_Lamp.efe500d5.png";